import { Injectable } from '@angular/core';
import { BOProduct, Images } from '@boels/models';
import { Observable, of } from 'rxjs';
import { JsonLdBuilder } from '../../structured-data.model';

type ProductBase = {
  sku?: string;
  brand: {
    '@type': string;
    name: string;
  };
  name?: string;
  description?: string;
  image?: string;
};
@Injectable()
export class JsonLdProductBaseBuilder implements JsonLdBuilder<BOProduct> {
  build(product: BOProduct): Observable<any> {
    return of({
      ...this.getProductBase(product),
      ...this.getProductImage(product.images),
    });
  }

  private getProductBase(product: BOProduct): ProductBase {
    const result: ProductBase = {
      sku: product.code,
      brand: {
        '@type': 'brand',
        name: 'boels',
      },
    };

    if (product.name) {
      result.name = product.name;
    }
    if (product.description) {
      result.description = product.description;
    }
    return result;
  }

  protected getProductImage(images: Images | any): { image?: string } {
    const image = Array.isArray(images)
      ? images?.find(
          (image) => image.imageType === 'PRIMARY' && image.format === 'zoom',
        )?.url
      : images?.PRIMARY?.['zoom']?.url;

    return image ? { image } : {};
  }
}
